export default __webpack_public_path__ + "static/media/png-icon.0e5c41a8.webp";